import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section, Reveal, SectionTitle } from './Section';
const antes = ['Llegabas a casa con una mochila llena de exámenes.', 'Los domingos terminaban siendo otro día de trabajo.', 'Escribías las mismas observaciones una y otra vez.', 'Perdías tiempo calculando notas manualmente.', 'Siempre sentías que ibas atrasada.'];
const despues = ['Corrige evaluaciones en una fracción del tiempo.', 'Utiliza exámenes diseñados para facilitar la corrección.', 'Da retroalimentación profesional con comentarios listos para usar.', 'Automatiza notas y registros sin complicaciones.', 'Recupera tus tardes, tus noches y tus domingos.'];
const stats = [{
  value: '10+',
  label: 'Horas recuperadas por semana'
}, {
  value: '6',
  label: 'Tomos completos'
}, {
  value: '6',
  label: 'Bonos Premium'
}, {
  value: 'De por vida',
  label: 'Acceso'
}];
export function BeforeAfter() {
  return <Section className="bg-white" data-id="element-21">
      <Reveal className="text-center" data-id="element-22">
        <SectionTitle data-id="element-23">
          De pasar horas corrigiendo… a terminar tus evaluaciones antes de que
          acabe la tarde.
        </SectionTitle>
        <p className="mx-auto mt-3 max-w-xl text-base font-semibold text-brand-purpleDark/70" data-id="element-24">
          Recupera el control de tu tiempo sin dejar de evaluar con calidad.
        </p>
      </Reveal>

      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-25">
        <Reveal className="rounded-3xl border-2 border-rose-100 bg-rose-50/60 p-5" data-id="element-26">
          <h3 className="mb-4 flex items-center gap-2 font-display text-lg font-extrabold text-rose-500" data-id="element-27">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-rose-500 text-white" data-id="element-28">
              <XIcon className="h-4 w-4" data-id="element-29" />
            </span>
            Antes
          </h3>
          <ul className="space-y-3" data-id="element-30">
            {antes.map(t => <li key={t} className="flex gap-2.5 text-sm font-semibold text-rose-900/80" data-id="element-31">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-400" data-id="element-32" />
                {t}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="rounded-3xl border-2 border-teal-100 bg-teal-50/60 p-5" data-id="element-33">
          <h3 className="mb-4 flex items-center gap-2 font-display text-lg font-extrabold text-brand-teal" data-id="element-34">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-teal text-white" data-id="element-35">
              <CheckIcon className="h-4 w-4" data-id="element-36" />
            </span>
            Con el Sistema
          </h3>
          <ul className="space-y-3" data-id="element-37">
            {despues.map(t => <li key={t} className="flex gap-2.5 text-sm font-semibold text-teal-900/80" data-id="element-38">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-teal" data-id="element-39" />
                {t}
              </li>)}
          </ul>
        </Reveal>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-40">
        {stats.map(s => <div key={s.label} className="rounded-2xl bg-brand-purple p-4 text-center text-white" data-id="element-41">
            <p className="font-display text-xl font-extrabold sm:text-2xl" data-id="element-42">
              {s.value}
            </p>
            <p className="mt-0.5 text-xs font-semibold text-white/75" data-id="element-43">
              {s.label}
            </p>
          </div>)}
      </div>
    </Section>;
}